import { render, staticRenderFns } from "./SuperkidHome.vue?vue&type=template&id=0cae38d1&scoped=true&"
import script from "./SuperkidHome.vue?vue&type=script&lang=js&"
export * from "./SuperkidHome.vue?vue&type=script&lang=js&"
import style0 from "./SuperkidHome.vue?vue&type=style&index=0&id=0cae38d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae38d1",
  null
  
)

export default component.exports